
import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { GroupsComponents } from "../react_isomorphic/groups";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";

window.ReactComponents = Object.assign(
  {},
  GlobalComponents,
  GroupsComponents,
  HeaderComponents
);

window.ReactStores = Object.assign(
  {},
  GlobalStores,
  HeaderStores
);
